// src/Components/Forms/Financement/Salam/Proposition/Tab3.tsx
import React from 'react';
import { Box, Grid } from '@mui/material';
import SetMultipleDocument from '../../../../SetMultipleDocument';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';

// Paramètres pour la recherche des documents par étape
let searchDocument: ParamsPicklist = {
  CodeAgence: 'SALAM',
  Table: "vw_DocumentsParEtape",
  Colonne1: "CodeEtape",
  Colonne2: "",
  Colagence: 'CodeProcessus',
  Init: 'PROPOSITION',
  Choix: 34
};

interface Tab3Props {
  form?: any;
  disabled?: boolean;
}

const Tab3 = (props: Tab3Props) => {
  return (
    <div className='tabItem'>
      <div>
        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}>
          <Grid item xs={12} md={12} lg={12}>
            <SetMultipleDocument
              form={props.form}
              Size="large"
              width={4}
              label="Documents"
              name="Documents"
              Parametre={searchDocument}
              disabled={props.disabled}
            />
          </Grid>
        </Box>
      </div>
    </div>
  );
};

export default Tab3;